import twMerge from 'utils/twMerge';

type FormColumnProps = {
    width?: string;
    className?: string;
};

const FormColumn: FC<FormColumnProps> = ({ width, className, children }) => {
    const styles = {
        ...(width !== undefined ? { width } : {}),
    };

    return (
        <div className={twMerge('-ml-3 flex flex-wrap [&>[data-testid="form-line"]]:pl-3', className)} style={styles}>
            {children}
        </div>
    );
};

/* @component */
export default FormColumn;
